import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "../Sidebar/Sidebar";

export const Layout = () => {
  return (
    <Flex>
      <Sidebar />
      <Box width="100%" paddingX="24px">
        <Outlet />
      </Box>
    </Flex>
  );
};
